import { CommonModule } from '@angular/common';
import { Component,  EventEmitter,  Input,  OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';


/**
 * Child Component which is a modal for Modify a setting value or a setting description
 */
@Component({
    selector: 'app-edit-settings-form',
    templateUrl: './edit-form.component.html',
    styleUrls: ['./edit-form.component.scss'],
    standalone: true,
    providers: [NgbModalConfig, NgbModal],
    imports: [TranslateModule, CommonModule, FormsModule, ReactiveFormsModule]
})
export class EditFormComponent implements OnInit {
  @Input() parameter?:string
  @Input() vselected?:any
  @Input() key?:string
  @Input() dico?:boolean
  @Input() ltocompare!:string[]
  @Output() eventEdit=new EventEmitter<string>()
  @Input() description?:boolean

  

  formEdit!:UntypedFormControl
  constructor(config: NgbModalConfig, private readonly modalService: NgbModal) {
    config.backdrop='static';
    config.keyboard=false;
   }

  /**
   * Init the form according to the type of setting define by ltocompare which is gift in parent component
   * 
   * They have some validator user must respect to modify his value
   */ 
  ngOnInit(): void {
    if(this.ltocompare===undefined){
      this.formEdit=new UntypedFormControl(this.vselected,[Validators.required, Backend.SETTINGS.noWhitespaceValidator()])
    }
    else{
      this.formEdit=new UntypedFormControl(this.vselected,[Validators.required, Backend.SETTINGS.notExistValidator(this.ltocompare), Backend.SETTINGS.noWhitespaceValidator()])
    }
  }

  open({content}: { content: any }){
    this.modalService.open(content, { centered: true })
  }

 sendValue(){
    this.eventEdit.emit(this.formEdit.value)
  }
}
